module.exports = "pegasus_template/assets/header-fall-pets-1.jpg";